const maxInitialsLength = 2;

export const getInitials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, maxInitialsLength)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
